export default "__VITE_ASSET__pA2VjDkT__"